import React from "react";
import classNames from "classnames";
import draggable from "fantastic/components/hoc/draggable";

const ItemEntity = ({ src }) => {

  const itemClass = classNames('fantastic-elements__item',{
    'fantastic-elements__item--wait': !src
  });

  return <div className={itemClass}>
    { src ? (
      <img src={src} />
    ) : (
      <span className="fantastic-elements__loading"/>
    ) }
  </div>;
};

export default draggable("ITEM")(ItemEntity);
